import { render, staticRenderFns } from "./Bg.vue?vue&type=template&id=fdcc358c&scoped=true&"
import script from "./Bg.vue?vue&type=script&lang=js&"
export * from "./Bg.vue?vue&type=script&lang=js&"
import style0 from "./Bg.vue?vue&type=style&index=0&id=fdcc358c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcc358c",
  null
  
)

export default component.exports